<script setup>
const props = defineProps({
    title: String,
});
</script>

<template>
    <div class="flex items-center gap-6">
        <div class="h-[1px] flex-1 bg-grey-100" />
        <h2 class="block font-jum-black text-2xl  uppercase">
            {{ title }}
            <slot />
        </h2>
        <div class="h-[1px] flex-1 bg-grey-100" />
    </div>
</template>


